import apiClient from "../core/HttpClient";
import { CharityIssueCategory } from "../models";
import { CharityIssueCategoryViewModel } from "../viewModels";

export default class CharityIssueCategoryService{
    url="/CharityIssueCategories";

    public async getCharityIssueCategories(): Promise<CharityIssueCategory[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getCharityIssueCategory(id: string): Promise<CharityIssueCategoryViewModel> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createCharityIssueCategory(charityIssueCategory: CharityIssueCategory) {
        return await apiClient.post(this.url, charityIssueCategory);
    }

    public async updateCharityIssueCategory(charityIssueCategory: CharityIssueCategory) {
        return await apiClient.put(`${this.url}/${charityIssueCategory.id}`, charityIssueCategory);
    }

    public async deleteCharityIssueCategory(id: number): Promise<void> {
        await apiClient.delete(`${this.url}/${id}`);
    }
    
}
